import React from 'react';
import cn from 'clsx';

import FilterChip from './components/filter-chip/filter-chip';

import styles from './filter-chips.scss';

export interface FilterChipValue {
  categoryCode?: string;
  categoryName?: string;
  valueCode?: string;
  valueName?: string;
}

interface FilterChipsProps {
  className?: string;
  filters?: FilterChipValue[];
  onChipClick: (filterChip: FilterChipValue) => void;
  onClearAllClick?: () => void;
  showClearAll?: boolean;
}

function FilterChips(props: FilterChipsProps) {
  const {
    className,
    filters = [],
    onChipClick,
    onClearAllClick,
    showClearAll = false
  } = props;

  return Array.isArray(filters) && filters.length > 0 ? (
    <div
      className={cn(styles['chip-container'], 'filter-chips', className)}
      data-testid="filter-chips"
    >
      {filters.map((chip, i) => (
        <FilterChip
          categoryCode={chip.categoryCode}
          categoryName={chip.categoryName}
          key={`crumb-${i}`}
          onClick={onChipClick}
          valueCode={chip.valueCode}
          valueName={chip.valueName}
        />
      ))}
      {showClearAll && filters.length > 1 && (
        <button
          className={cn(styles['clear-all'], 'filter-chips__clear-all-button')}
          onClick={onClearAllClick}
        >
          clear all
        </button>
      )}
    </div>
  ) : null;
}

export default React.memo(FilterChips);
